// app.ajax
(function(app, $) {

    var currentRequests = [];
    // request cache

    // sub namespace app.ajax.* contains application specific ajax components
    app.ajax = {
        // ajax request to get json response
        // @param - async - boolean - asynchronous or not
        // @param - url - String - uri for the request
        // @param - data - name/value pair data request
        // @param - callback - function - callback function to be called
        getJson : function(options) {
            options.url = app.util.toAbsoluteUrl(options.url);
            // return if no url exists or url matches a current request
            if(!options.url || currentRequests[ options.url ]) {
                return;
            }

            currentRequests[ options.url ] = true;

            // make the server call
            $.ajax({
                    dataType   : "json",
                    url        : options.url,
                    async      : (typeof options.async === "undefined" || options.async === null) ? true : options.async,
                    data       : options.data || {},
                    type       : options.type || "GET",
                    beforeSend : function(jqXHR, settings) {
                        jqXHR.setRequestHeader('dw-x-requested-with', 'XMLHttpRequest');
                    }
                })
                // success
                .done(function(response) {
                    if(options.callback) {
                        options.callback(response);
                    }
                })
                // failed
                .fail(function(xhr, textStatus) {
                    if(textStatus === "parsererror") {
                        window.alert(app.resources.badresponse);
                    }
                    if(options.callback) {
                        options.callback(null);
                    }
                })
                // executed on success or fail
                .always(function() {
                    // remove current request from hash
                    if(currentRequests[ options.url ]) {
                        delete currentRequests[ options.url ];
                    }
                });
        },
        // ajax request to load html response in a given container

        // @param - url - String - uri for the request
        // @param - data - name/value pair data request
        // @param - callback - function - callback function to be called
        // @param - beforeTargetUpdate - function - callback function for response transformation, must return response
        // @param - target - Object - Selector or element that will receive content
        load : function(options) {
            options.url = app.util.toAbsoluteUrl(options.url);
            // return if no url exists or url matches a current request
            if(!options.url || currentRequests[ options.url ]) {
                return;
            }

            // make the server call
            var jqxhr = $.ajax({
                dataType   : ("undefined" !== typeof(options.dataType)) ? options.dataType : "html",
                url        : app.util.appendParamToURL(options.url, "format", "ajax"),
                data       : options.data,
                type       : options.type || "GET",
                beforeSend : function(jqXHR, settings) {
                    jqXHR.setRequestHeader('dw-x-requested-with', 'XMLHttpRequest');
                }
            });

            jqxhr.done(function(response, status, xhr) {
                    if(currentRequests[ options.url ]) {
                        delete currentRequests[ options.url ];
                    }
                    //beforeTargetUpdate
                    if(typeof options.beforeTargetUpdate === 'function') {
                        response = options.beforeTargetUpdate(response);
                    }
                    // success
                    if(options.target) {
                        if(options.beforeLoad) {
                            options.beforeLoad(response, status, xhr);
                        }
                        $(options.target).empty().html(response).trigger("update", response);
                    }
                    if(options.callback) {
                        options.callback(response, status, xhr);
                    }
                })
                .fail(function(xhr, textStatus) {
                    // failed
                    ('callback' in options) && options.callback(null, textStatus);
                })
                .always(function() {
                });

            return jqxhr;
        }
    };
}(window.app = window.app || {}, jQuery));
